var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "invalid-icon-medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Art"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V32H26V0Z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.64.78A2.71,2.71,0,0,0,18,.1H1A.9.9,0,0,0,.1,1V31a.9.9,0,0,0,.9.9H13L25.9,19V8a2.71,2.71,0,0,0-.68-1.64ZM24.1,19.24l-5.82-5.82a.37.37,0,0,0-.54,0l-6.33,7.15a.57.57,0,0,1-.83,0l-3.3-3.29a.35.35,0,0,0-.53,0L1.9,23V1.9H17A1.1,1.1,0,0,1,18.1,3V8a.9.9,0,0,0,.9.9h4A1.1,1.1,0,0,1,24.1,10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25,31.9a.9.9,0,0,0,.9-.9V23.48L17.48,31.9Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 3.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidIconMedium);
export default __webpack_public_path__ + "static/media/invalid-icon-medium.58305dded85682d90d4c1772efbf1185.svg";
export { ForwardRef as ReactComponent };